import React, { useEffect, useState } from 'react';
import { Button, Checkbox, TextField } from '@mui/material';
import ReactModal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { getUsersList, onlySharedAdminUsersList, resetOnlySharedAdminUsers, shareLabelToAdminUser } from '../redux/actions/userActions';
import { Label } from '@mui/icons-material';

const customModalStyles = {
    overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1000,
        marginTop: '2em'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'white',
        borderRadius: '8px',
        maxWidth: '40%',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.3)',
    },
};

const ShareLabelModal = ({ open, onClose, label }) => {
    const dispatch = useDispatch();
    const [selectedAdminUserIds, setSelectedAdminUserIds] = useState([]);
    const [removedAdminUserIds, setRemovedAdminUserIds] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [adminUsers, setAdminUsers] = useState([]);

    const userDetails = useSelector((state) => state.user.userDetails);
    const onlySharedAdminUsers = useSelector(state => state.user.onlySharedAdminUsers);

    const adminUserList = useSelector((state) => state.user.usersList);

    useEffect(() => {
        let aJson = {
            "labelId": label.id
        }
        dispatch(onlySharedAdminUsersList(aJson));

        dispatch(getUsersList());

        return () => {
            dispatch(resetOnlySharedAdminUsers());
        }
    }, []);

    useEffect(() => {
        setAdminUsers(adminUserList.filter(user => user.id != userDetails?.adminUserId));
    }, [adminUserList, userDetails])

    useEffect(() => {
        setSelectedAdminUserIds(onlySharedAdminUsers);
    }, [onlySharedAdminUsers])

    const handleShareLabel = async () => {
        if (selectedAdminUserIds?.length > 0 || removedAdminUserIds?.length > 0) {
            const payload = {
                'labelId': label.id,
                'adminUserIds': selectedAdminUserIds,
                'removedAdminUserIds': removedAdminUserIds
            }

            setIsSaving(true);
            await dispatch(shareLabelToAdminUser(payload));
            setIsSaving(false);
            onClose();
        }

    }

    const handleSelectAdminUser = (adminUser) => {
        if (selectedAdminUserIds?.includes(adminUser.id)) {
            setSelectedAdminUserIds(prevState => prevState.filter(item => item != adminUser.id));
        } else {
            setSelectedAdminUserIds([...selectedAdminUserIds, adminUser.id]);

            if (removedAdminUserIds.includes(adminUser.id)) {
                setRemovedAdminUserIds(prevState => prevState.filter(item => item != adminUser.id));
            }
        }

        if (onlySharedAdminUsers?.includes(adminUser.id) && !removedAdminUserIds.includes(adminUser.id)) {
            setRemovedAdminUserIds([...removedAdminUserIds, adminUser.id]);
        }
    }

    return (
        <>
            <ReactModal
                isOpen={open}
                onRequestClose={onClose}
                contentLabel="Share Label Modal"
                style={customModalStyles}
            >
                <div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <span style={{ fontSize: '18px', fontWeight: 'bold' }}>Share Label:</span>
                        <Label style={{ color: label.color, marginLeft: '12px' }} />
                        <span style={{ marginLeft: '8px' }}>{label.name}</span>
                    </div>

                    <div style={{}}>
                        {adminUsers?.map((adminUser) =>
                            <div
                                onClick={() => handleSelectAdminUser(adminUser)}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    padding: '8px',
                                    cursor: 'pointer',
                                    borderRadius: '4px'
                                }}>
                                <div style={{ flex: 1, marginLeft: '8px' }}>
                                    {adminUser.name}
                                </div>
                                <Checkbox
                                    style={{ alignSelf: 'flex-end' }}
                                    size='small'
                                    checked={selectedAdminUserIds?.some((c) => c === adminUser.id)}
                                />
                            </div>
                        )}
                    </div>

                    <div style={{ marginTop: '24px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <Button
                            style={{ width: '120px' }}
                            size='small'
                            variant='outlined'
                            onClick={onClose}
                        >Cancel</Button>
                        <Button
                            style={{ marginLeft: '12px', width: '120px' }}
                            size='small'
                            variant='contained'
                            onClick={handleShareLabel}
                            disabled={selectedAdminUserIds?.length == 0 && removedAdminUserIds?.length == 0}
                        >{isSaving ? 'Sharing' : 'Share'}</Button>

                    </div>

                </div>
            </ReactModal>
        </>
    );
};

export default ShareLabelModal;
